<template>
  <div class="setting-chart-modal">
    <base-modal overflow-y-visible :size="'lg'" :modal-id="'setting-chart-modal'" :is-modal-open="isOpen" hide-footer @hide="onCloseModal">
      <template #modal-header>
        <div class="title">
          <paint-bucket class="me-2" />
          <span> {{ t('bi.setting_chart') }} </span>
        </div>
      </template>
      <template #modal-body>
        <div class="my-2">
          <div class="text-black-50">{{ t('bi.chart_name') }}:</div>
          <strong>{{ name }}</strong>
        </div>
        <hr />
        <div class="my-2">
          <div class="text-black-50">{{ t('bi.chart_type') }}:</div>
          <custom-vue-select
            :icon-color="'#007fff'"
            class="mt-1 setting-chart-vue-select"
            :clearable="false"
            v-model="selectedChartType"
            :options="typeList"
            placeholder="Select chart type"
          />
        </div>
        <hr />
        <div class="setting-color-wrp" v-if="itemProperty && itemProperty?.length > 0">
          <div class="text-black-50">{{ t('bi.color') }}:</div>
          <div class="position-relative">
            <ItemProperties v-for="item in itemProperty" :key="item.colorId + item.color" :items="item" @on-items-changed="onItemsChanged" />
          </div>
        </div>
        <div v-else class="no-color">{{ t('bi.no_color') }}</div>
      </template>
      <template #modal-footer>
        <div class="d-flex justify-content-center setting-chart-action-wrp">
          <button class="setting-chart-btn-cancel" @click="onCancel">{{ t('bi.cancel') }}</button>
          <div v-if="!loading">
            <button class="setting-chart-btn-add" @click="onApply">{{ t('bi.apply') }}</button>
          </div>
          <button v-else class="setting-chart-btn-add" type="button" disabled>
            {{ t('bi.apply') }}
            <span class="ml-sm spinner-border spinner-border-sm" role="status"></span>
          </button>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import PaintBucket from '@/assets/icons/modules/analytics/bi/PaintBucket.vue';
import BaseModal from '@/views/components/modal/BaseModal.vue';
import useSettingChartModal from './hooks/useSettingChartModal';
import ItemProperties from './ItemProperties.vue';
import CustomVueSelect from '@/views/components/custom-v-select/CustomVueSelect.vue';

interface Props {
  isOpen: boolean;
  name: string;
  typeSelected: string | null | undefined;
  typeList: string[];
  itemProperty: SettingChartModal.ItemProperty[];
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
});

defineEmits(['close-modal', 'cancel', 'apply']);

const { t } = useI18n();

const { loading, selectedChartType, onCloseModal, onCancel, onApply, onItemsChanged } = useSettingChartModal(props);
</script>

<style lang="scss">
@import '@/assets/styles/modules/analytics/bi/analytics-setting-chart-modal.scss';
</style>
